import { Avatar } from "@shared/components";
import { Container } from "./styles";
import { UserRankingItemProps } from "./types";

export function UserRankingItem({ name, photo, usage }: UserRankingItemProps)  {
  return (
    <Container>
      <Avatar
        src={photo as string}
        name={name}
        size={42}
      />

      <span>
        <strong>{name}</strong>
        <p>{usage} utilizações</p>
      </span>
    </Container>
  );
}
